const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const sites = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case "CLEAR_SITES_CACHE":
      return { ...state, data: [] };

    case "SET_CAMPAIGN_SITES":
      return { ...state, data: action.data };

    case "UPDATE_SITE":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case "REMOVE_SITE":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case "INSERT_SITE":
      return { ...state, data: [...state.data, action.data] };

    case "SET_CAMPAIGN_SITES_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_CAMPAIGN_SITES_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default sites;
